export { default } from './AppRegistrationView';
